module.exports = __webpack_public_path__ + "static/img/seun_findworka.24813c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seun_findworka.jpg
// module id = hvSX
// module chunks = 1